
import { Alert, Button, Form, Modal } from "react-bootstrap";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import { MuniSpinner2 } from "../../../components";
import { useEffect, useState } from "react";
import useActas from "../../../api/actas";
import useMotivos from "../../../api/motivos";
import { useMotivosStore } from "../../../store/motivosStore";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";


const ModalNotificarDigital = ({ titleModal, titleMensaje, mensaje, variant, confirm }) => {
    const { modals, handlerModal, loads } = useGeneralAppStore();
    const { acta } = useActaDetalleStore()
    const { anularActa, notificarActaDigital } = useActas()
    const { getMotivos } = useMotivos()
    const { motivos } = useMotivosStore();

    const [motivo, setMotivo] = useState("");
    const [opcionMotivo, setOpcionMotivo] = useState("No selecciono motivo");

    useEffect(() => {
        if (!motivos) {
            getMotivos();
        }
    }, [])

    return (
        <>


            <Modal
                show={modals.includes('modal_notificar_digital')}
                onHide={() => handlerModal({ modal: false, modalName: "modal_notificar_digital" })}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                style={{
                    backgroundColor: modals.length > 1 && modals[0] === 'acta_detalle' ? 'rgba(0,0,0,0.4)' : '',
                    // opacity: modals.length > 1 && modals[0] === 'acta_detalle' ? '.1' : '1',        
                }}
            // className="position-relative"
            >
                <div className="position-relative">
                    {
                        (loads.includes('modal_notificar_digital')  || loads.includes('motivos')) &&
                        <div className=" d-flex justify-content-center align-items-center position-absolute w-100 h-100 z-3" style={{ backgroundColor: "rgba(255,255,255,0.7)" }}>
                            <MuniSpinner2 />
                        </div>
                    }
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {titleModal}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="d-flex flex-column gap-3">
                            <Alert variant="success">
                                <h4 className="text-success text-center py-4 m-0">{titleMensaje}</h4>
                            </Alert>




                            {/* <div className="d-flex gap-2">
                                <span className="fw-bold text-primary">Motivo:</span>
                                <span className={`${opcionMotivo == "No selecciono motivo" && "text-danger"} fw-medium`}>{opcionMotivo}</span>
                            </div> */}

                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => notificarActaDigital({ id: acta.id })} variant="success">Confirmar</Button>
                        <Button onClick={() => handlerModal({ modal: false, modalName: "modal_notificar_digital" })}>Close</Button>
                    </Modal.Footer>
                </div>
            </Modal>


        </>
    );
}
export default ModalNotificarDigital;